import React, { memo } from "react";
import ReactECharts from 'echarts-for-react';
import _ from "lodash";
import PropTypes from 'prop-types';

const PieChart = (props) => {

    const {
         chartData,
  colors,
  events,
  FloatValue,
  legendData,
  onChartClick,
  percentages,
  position,
  radius,
  showlabel,
  showLegend,
  showPercent,
  showTitle,
  spaceBottom,
  sprintTitle,
  titleFontSize,
  toolTipConfig,
  showtool } = props;

    let data;
    const updatedData = legendData.map(label => {
        const existingItem = chartData.find(item => item[label] !== undefined);
    
        // If the label is not found in the data, add it with a value of 0
        if (!existingItem) {
          return {
            [label]: "0"
          };
        }
    
        return existingItem;
      });
    if (!Array.isArray(updatedData)) {
        data = updatedData;
    }  else if(FloatValue){
        data = updatedData.map((item) => {
            const [label, value] = Object.entries(item)[0];
            return value;
        });
    } else {
        data = updatedData.map((item) => {
            const [label, value] = Object.entries(item)[0];
            return parseInt(value);
        });
       
    }

    const totalValue = data ? Object.values(data).reduce((sum, value) => sum + value, 0) : "";

    const getPieOption = () => {
        const options = {
            tooltip: {
                show: showtool === false ? false : true,
                trigger: 'item',
                formatter: function (params) {
                    return `
                    <div style="width: 100%;">
                        <table style="width: 100%; border-spacing: 0; border-collapse: collapse;">
                          <tr>
                            <td style="text-align: left;">${params.marker} ${params.name} </td>
                        <td style="text-align: right;"><b>${params.value.toLocaleString()}</b></td>
                          </tr>
                        </table>
                      </div>`;  
                  }
            },
            tooltip: toolTipConfig ? { ...toolTipConfig } : {
                show: true,
                trigger: 'item',

            },
            title: [      
                  {
                    show: showTitle === true ? true : false,
                    text: `${sprintTitle}`,
                    x: "center",
                    y: 230,
                    textStyle: {
                      fontSize: titleFontSize ? titleFontSize : 9,
                    }
                },
                {
                    show: showPercent === true ? true : false,
                    text: ` ${percentages}`,
                    x: "center",
                    y: "center",
                    textStyle: {
                      fontSize: 15,
                    }
                }
              ],
            legend: {
                type: 'scroll',
                orient: "horizontal",
                left: "left",
                right: 10,
                top: "top",
                show: showLegend === undefined ? true : showLegend,
                data: legendData || (data ? Object.keys(data) : []),
                icon: 'circle',
                textStyle: {
                    color: 'grey',
                },
            },
            series: [{
                type: "pie",
                center: ['50%', spaceBottom ? spaceBottom : '50%'], 
                radius: (radius ? radius : "60%"),
                data: Object.keys(data).map((key, index) => ({
                    name: legendData && legendData[index] ? legendData[index] : key,
                    value: data[key]!=0?data[key]:null,
                    itemStyle: {
                        color: colors && colors[index] ? colors[index] : undefined,
                    }
                })),
                label: {
                    show: showlabel === false ? false : true,
                    position: (position ? position : "outside"),
                    formatter: '{d}%'
                },
            }]
        };
        return options;
    };
    const handleChartClick = (params) => {
        onChartClick(params);
    };
    const onEvents = {
        'click': handleChartClick, 
    };
    return (
        <div>
            <ReactECharts option={getPieOption()} onEvents={events ? onEvents : ""}/>
        </div>
    );
};
function areEqual(prevProps, nextProps) {
    if(_.isEqual(prevProps.chartData, nextProps.chartData) &&
    _.isEqual(prevProps.colors, nextProps.colors) &&
    _.isEqual(prevProps.legendData, nextProps.legendData) &&
    _.isEqual(prevProps.position, nextProps.position) &&
    _.isEqual(prevProps.showLegend, nextProps.showLegend) &&
    _.isEqual(prevProps.showTitle, nextProps.showTitle) &&
    _.isEqual(prevProps.countTitle, nextProps.countTitle) &&
    _.isEqual(prevProps.spaceBottom, nextProps.spaceBottom) &&
    _.isEqual(prevProps.events, nextProps.events) &&
    _.isEqual(prevProps.countTitle, nextProps.countTitle)) {
        return true;
    } else {
        return false;
    }
}

PieChart.propTypes = {
  chartData: PropTypes.arrayOf(PropTypes.object).isRequired,
  colors: PropTypes.arrayOf(PropTypes.string),
  events: PropTypes.bool,
  FloatValue: PropTypes.bool,
  legendData: PropTypes.arrayOf(PropTypes.string),
  onChartClick: PropTypes.func,
  percentages: PropTypes.string,
  position: PropTypes.string,
  radius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showlabel: PropTypes.bool,
  showLegend: PropTypes.bool,
  showPercent: PropTypes.bool,
  showTitle: PropTypes.bool,
  spaceBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sprintTitle: PropTypes.string,
  titleFontSize: PropTypes.number,
  toolTipConfig: PropTypes.object,
  showtool: PropTypes.bool,
};

export default memo(PieChart, areEqual);



